'use strict';

angular.module('nl2br', [
    'ngSanitize',
])
    .filter('nl2br', function() {
        return function(input) {
            return !input ? input : input.split('\n').join('<br>');
        };
    });
